// src/lib/layouts/applyClipRatioToRect.ts
import { clampClipRatio } from './clampClipRatio';
import {
  classifyFillerSide,
  isValidFractionalRect,
  type FractionalRect,
} from './deriveClipPosition';

const clamp = (v: number, lo: number, hi: number) => Math.min(hi, Math.max(lo, v));

/** Resize a free-floating satisfatorio cell to `ratio`% of the split axis
 *  (height in portrait, width in landscape), moving the edge that faces the
 *  filler strip and anchoring the opposite edge. With the strip on the cross
 *  axis, the leading edge stays anchored. Clamped to the canvas; junk rects
 *  are returned unchanged. clampClipRatio keeps the size within 10–90%, so
 *  the result can never violate the editor's MIN_SIZE (0.1). */
export function applyClipRatioToRect(
  rect: FractionalRect,
  ratio: number,
  isLandscape: boolean,
): FractionalRect {
  if (!isValidFractionalRect(rect)) return rect;
  const frac = clampClipRatio(ratio) / 100;
  const side = classifyFillerSide(rect, isLandscape);

  if (isLandscape) {
    // 'before' = filler on the left → the LEFT edge moves, right edge anchors.
    const x = side === 'before' ? rect.x + rect.w - frac : rect.x;
    return { ...rect, x: clamp(x, 0, 1 - frac), w: frac };
  }
  const y = side === 'before' ? rect.y + rect.h - frac : rect.y;
  return { ...rect, y: clamp(y, 0, 1 - frac), h: frac };
}
